import React, { useState, useMemo } from "react";
import { Container } from "reactstrap";
import { useSelector } from "react-redux";

import { DF_OT0016Context } from "./context";
import GridHeader from "./Grid/GridHeader";
import GridBody from "./Grid/GridBody";

import { fnGetValueByKey } from "../../helpers/functions";
import withRouter from "../../components/Common/withRouter";
import useGetCsrfToken from "../../Hooks/useGetCsrfToken";

const DF_OT0016 = (props) => {
  const navigate = props.router?.navigate || props.navigate;

  const userProfile = useSelector((state) => state.login.profile);
  const isModalPage = useSelector((state) => state.Layout.isModalPage);
  const accessToken = useSelector((state) => state.login.user?.access_token);

  const csrfToken = useGetCsrfToken();

  const [isLoading, setisLoading] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [paramsOnFilter, setParamsOnFilter] = useState([]);
  const [triggerOnFilter, setTriggerOnFilter] = useState(false);
  const [inputGlobalSearchValue, setInputGlobalSearchValue] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [columns, setColumns] = useState([]);

  const contextValue = useMemo(
    () => ({
      isLoading,
      setisLoading,
      isOpenModal,
      setIsOpenModal,
      paramsOnFilter,
      setParamsOnFilter,
      triggerOnFilter,
      setTriggerOnFilter,
      inputGlobalSearchValue,
      setInputGlobalSearchValue,
      filteredData,
      setFilteredData,
      columns,
      setColumns,
      userProfile,
      accessToken,
      csrfToken,
      fnGetValueByKey,
      navigate,
    }),
    [
      isLoading,
      isOpenModal,
      paramsOnFilter,
      triggerOnFilter,
      inputGlobalSearchValue,
      filteredData,
      columns,
      userProfile,
      accessToken,
      csrfToken,
      navigate,
    ]
  );

  const containerClasses = `page-content min-vh-100 ${isModalPage ? "p-0 overflow-hidden" : "overflow-visible"
    }`;

  return (
    <DF_OT0016Context.Provider value={contextValue}>
      <div className={containerClasses}>
        <Container fluid className="dataTable-custom-primary">
          <GridHeader />
          <GridBody />
        </Container>
      </div>
    </DF_OT0016Context.Provider>
  );
};

export default withRouter(DF_OT0016);